import React, { useEffect } from "react";
import Localize from "react-intl-universal";

import { Dimmer, Loader } from "semantic-ui-react";
import GlobalList from "../../Components/Lists/GlobalList";
import usePartnerServices from "../../RestServicesNew/usePartnerServices.js";
import styles from "./style/ErrorLog.module.css";

const ErrorLog = ({ errorLogs, fetchErrorLogsCall, errorLogsLoading }) => {
  useEffect(() => {
    fetchErrorLogsCall();
  }, []);

  return (
    <>
      <Dimmer active={errorLogsLoading} inverted>
        <Loader size="large" disabled={!errorLogsLoading}>
          {Localize.get("DASHBOARD.LOADING")}
        </Loader>
      </Dimmer>

      <div className={`fifteen wide column items_list`}>
        <GlobalList
          currentView="details"
          listState={errorLogs}
          itemHandler={() => {}}
          listPaginationCustomCSS={styles.template_list}
          availableItemFieldsForList={[
            {
              name: "dateAndTime",
              hederName: "DOCUMENTS.DETAILS.DOCUMENT_DATE",
              type: "text",
              width: 2,
              visible: true
            },
            {
              name: "partner.name",
              hederName: "CONTACTS.LIST.HEADER.NAME",
              type: "text",
              width: 3,
              visible: true
            },
            {
              name: "partner.invoiceName",
              hederName: "CONTACTS.INVOICE_NAME",
              type: "text",
              width: 5,
              visible: true
            },
            {
              name: "errorMessage",
              hederName: "SETTINGS.HEADERS.ERROR_MESSAGE",
              type: "text",
              width: 6,
              visible: true
            }
          ]}
        />
      </div>
    </>
  );
};

export default ErrorLog;
